export const API_BASE = "https://webappagentkai.azurewebsites.net/planproduct";

export function normalizeApiBase(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

export function apiUrl(path) {
  const base = normalizeApiBase(API_BASE);
  const p = String(path || "");
  if (!p) return base;
  if (p.startsWith("/")) return `${base}${p}`;
  return `${base}/${p}`;
}
